import React, { useEffect, useState } from 'react';

const Timer = ({ timeUp, restart, setGiocatori, setDificolta, setMultipleDifficolta, setAvvia,setLoss }) => {
  const storedTime = localStorage.getItem('selectedTime');
  const defaultTotalTime = 60; // Default total time in seconds
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const [timeLeft, setTimeLeft] = useState(defaultTotalTime);
  const [progressWidth, setProgressWidth] = useState('0%');
  const [totalTime, setTotalTime] = useState(defaultTotalTime);
  const [refresh, setRefresh] = useState(false);

  const handleRefresh = () => {
    setRefresh(true);
  };

  useEffect(() => {
    let convertedTime = defaultTotalTime;

    if (storedTime) {
      const timeInSeconds = parseInt(storedTime);
      if (!isNaN(timeInSeconds)) {
        convertedTime = timeInSeconds;
      }
    }

    setTimeLeft(convertedTime);
    setTotalTime(convertedTime);
  }, [storedTime]);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    if (timeLeft === 0 || timeUp) {
      clearInterval(timerInterval);
      if (timeLeft === 0) {
        localStorage.removeItem('selectedTime');
        localStorage.removeItem('selectedSecond');
        setLoss(true); // Redirect to the first question
        setDificolta(false)
        setMultipleDifficolta(false)
        setAvvia(false)
        setTimeLeft(totalTime); // Reset the timer
      }
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [timeLeft, timeUp]);
 


  useEffect(() => {
    if (restart) {
      setTimeLeft(totalTime);
      setProgressWidth('0%');
    }
  }, [restart, totalTime,]);

  useEffect(() => {
    const progressPercentage = ((totalTime - timeLeft) / totalTime) * 100;
    setProgressWidth(`${progressPercentage}%`);
  }, [timeLeft, totalTime]);

  const timerMinutes = Math.floor(timeLeft / 60);
  const timerSeconds = timeLeft % 60;
  const formattedTime = `${timerMinutes.toString().padStart(2, '0')}:${timerSeconds.toString().padStart(2, '0')}`;

  return (
    <div>
      <div className="timer">{formattedTime}</div>
      <div className={timeUp ? "timer_inner_div_3" : "timer_inner_div_1"}>
        <div className="timer_inner_div_2" style={{ width: progressWidth }}></div>
      </div>
    </div>
  );
};

export default Timer;
